<a [routerLink]="['/horario', 'listado']">
  <button mat-raised-button color="primary">Volver</button>
</a>
<div class="calendario-container mat-elevation-z8">
  <mat-horizontal-stepper [linear]="true" #stepper labelPosition="bottom" >
    <mat-step [stepControl]="archivoForm">
      <ng-template matStepLabel>Cargar<br>archivo</ng-template>
      <div class="small-container">
        <app-calendario-importar-cargar-archivo [escuelas$]="escuelas$" [archivoForm]="archivoForm" [loading$]="loading$"
          (fileSelectEvent)="fileProgress($event)"></app-calendario-importar-cargar-archivo>
        <div class="buttons-container">
          <button mat-raised-button color="primary" matStepperNext (click)="archivoForm.markAllAsTouched()" [disabled]="loading$ | async">Siguiente</button>
        </div>
      </div>
    </mat-step>
    <mat-step [stepControl]="formClasses">
      <ng-template matStepLabel>Emparejar<br>cursos</ng-template>
      <div *ngIf="stepper.selectedIndex === 1">
        <div class="big-container">
          <app-calendario-importar-emparejar *ngIf="data" [form]="formClasses" aEmparejar="Cursos"
            [objetos]="data.classes" [opciones$]="cursos$"></app-calendario-importar-emparejar>
          <div class="buttons-container">
            <button mat-button matStepperPrevious>Anterior</button>
            <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Verificar cursos<br>emparejados</ng-template>
      <div *ngIf="stepper.selectedIndex === 2">
        <div class="big-container">
          <app-calendario-importar-verificar *ngIf="data" [form]="formClasses" propiedad="curso" aEmparejar="Cursos"
            [objetos]="data.classes" [opciones$]="cursos$"></app-calendario-importar-verificar>
          <div class="buttons-container">
            <button mat-button matStepperPrevious>Anterior</button>
            <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step [stepControl]="formSubjects">
      <ng-template matStepLabel>Emparejar<br>materias</ng-template>
      <div *ngIf="stepper.selectedIndex === 3">
        <app-calendario-importar-emparejar *ngIf="data" [form]="formSubjects" aEmparejar="Materias"
          [objetos]="data.subjects" [opciones$]="materias$"></app-calendario-importar-emparejar>
      </div>
      <div class="buttons-container">
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Verificar materias<br>emparejadas</ng-template>
      <div *ngIf="stepper.selectedIndex === 4">
        <app-calendario-importar-verificar *ngIf="data" [form]="formSubjects" propiedad="materia" aEmparejar="Materias"
          [objetos]="data.subjects" [opciones$]="materias$"></app-calendario-importar-verificar>
      </div>
      <div class="buttons-container">
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="formSubjects">
      <ng-template matStepLabel>Emparejar<br>profesores</ng-template>
      <div *ngIf="stepper.selectedIndex === 5">
        <app-calendario-importar-emparejar *ngIf="data" [form]="formTeachers" aEmparejar="Profesores"
          [objetos]="data.teachers" [opciones$]="profesores$"></app-calendario-importar-emparejar>
      </div>
      <div class="buttons-container">
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Verificar profesores<br>emparejados</ng-template>
      <div *ngIf="stepper.selectedIndex === 6">
        <app-calendario-importar-verificar *ngIf="data" [form]="formTeachers" propiedad="profesor" aEmparejar="Profesores"
          [objetos]="data.teachers" [opciones$]="profesores$"></app-calendario-importar-verificar>
      </div>
      <div class="buttons-container">
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Finalizar</ng-template>
      <div class="small-container">
        <p class="resaltado-resultados">Se importarán {{numeroRegistros()}} registros de horario para {{escuela$ | async}}.</p>
        <p>Seleccione la fecha a partir de la cual este horario entrará en vigencia.</p>
        <div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Fecha inicial</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="fechaForm">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-error *ngIf="fechaForm.invalid && fechaForm.touched">
            {{'Este campo es requerido.'}}
          </mat-error>
          <div class="buttons-container">
            <button mat-raised-button (click)="submit()" color="primary">Enviar</button>
            <button *ngIf="terminado$ | async" mat-raised-button (click)="nuevaImportacion()" color="primary">Nueva importación</button>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
